import { FieldValues } from 'react-hook-form/dist/types'
import { isDate, isEmpty, isNaN } from 'lodash'

export default function isFieldsFilled(
  fields: string[],
  values: FieldValues,
  checkFn: 'some' | 'every'
): boolean {
  return fields[checkFn]((fieldName) => {
    const fieldValue = values[fieldName]
    if (
      (typeof fieldValue === 'boolean' && fieldValue) ||
      (isDate(fieldValue) && !isNaN(fieldValue?.valueOf()))
    ) {
      return true
    }

    return !isEmpty(fieldValue)
  })
}
